<template>
  <!-- 

  [ 간격 옵션 / defauly : spacing--sm ]
  .spacing--sm
  .spacing--md
  .spacing--lg
  .spacing--no

  [ 폰트크기 옵션 / default : font--md ]
  .font--xs
  .font--sm
  .font--md
  .font--lg
  .font--xl


  [ 폰트두께 옵션 / default : font--400 ]
  .font--100
  .font--200
  .font--300
  .font--400
  .font--500
  .font--600
  .font--700
  .font--800
  .font--900  


  [ 보더옵션 / default : 없음 ]
  .border--solid
  .border--dashed


  [ 색상 테마 옵션 / default : theme--black ]
  .theme--black : 메뉴 폰트, 아이콘 검정
  .theme--white : 메뉴 폰트, 아이콘 흰색

  -->
  <!-- 소메뉴 -->
  <div class="menu-sm__container option spacing--sm font--sm">
    <ul>
      <li
        class="menu-sm__item"
        v-for="menu in menus"
        :key="menu.seq"
      >
        <a
          @click="menuClick(menu)"
          class="menu-sm"
        >
          <span class="menu-sm__label">{{menu.menuName}}</span>
        </a>
      </li>
      <!-- <li class="menu-sm__item is-selected">
        <a
          href="#"
          class="menu-sm"
        >
          <span class="menu-sm__label">중메뉴</span>
        </a>
      </li> -->
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    menus: { type: Array },
    menuClick: { type: Function }
  }
}
</script>
